var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconProfile = function SvgIconProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    x: 3.5,
    y: 3.5,
    stroke: "currentColor",
    rx: 3.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M7 11.044c.406-1.015 1.712-3 2.74-1.827 2.13 2.435 3.347-.304 3.955-1.217"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#fff",
    d: "M12.397 12.309c.299-.921 1.602-.921 1.902 0l.164.505h.53c.968 0 1.371 1.239.588 1.808l-.43.312.164.505c.3.92-.755 1.686-1.539 1.117l-.428-.312-.43.312c-.783.569-1.837-.196-1.538-1.118l.164-.504-.429-.312c-.784-.57-.38-1.809.588-1.809h.53z"
  })));
};
export default SvgIconProfile;